import { Navigate, Route, Routes as RouterRoutes } from 'react-router-dom';

import { LocalDevSignin } from './pages/LocalDev/Signin';
import Activity from './routes/Activity';
import Approvals from './routes/Approvals';
import Security from './routes/Security';
import Settings from './routes/Settings';
import Team from './routes/Team';

export function Routes() {
  return (
    <RouterRoutes>
      <Route path="/local-dev/signin" element={<LocalDevSignin />} />
      <Route path="/" element={<Navigate to="/team" replace />} />
      <Route path="/team/*" element={<Team />} />
      <Route path="/activity/*" element={<Activity />} />
      <Route path="/security/*" element={<Security />} />
      <Route path="/approvals/*" element={<Approvals />} />
      <Route path="/settings/*" element={<Settings />} />
      <Route path="*" element={<Navigate to="/team" replace />} />
    </RouterRoutes>
  );
}
